(function () {
  var STORAGE_KEY = 'ci-recently-viewed';
  var MAX_ITEMS = 12;

  function readHandles() {
    try {
      var list = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  function saveHandles(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      /* ignore */
    }
  }

  function trackHandle(handle) {
    if (!handle) return;
    var list = readHandles().filter(function (h) {
      return h && h !== handle;
    });
    list.unshift(handle);
    saveHandles(list.slice(0, MAX_ITEMS));
  }

  if (window.ciCurrentProductHandle) {
    trackHandle(window.ciCurrentProductHandle);
  }

  function initSlider(slider) {
    if (!slider || slider.dataset.ciRvSliderReady === 'true') return;
    slider.dataset.ciRvSliderReady = 'true';

    var viewport = slider.querySelector('.ci-fc__viewport');
    var track = slider.querySelector('.ci-fc__track');
    if (!viewport || !track) return;

    var section = slider.closest('[data-ci-recently-viewed]');
    var prevBtn = section ? section.querySelector('.ci-fc__nav-btn--prev') : null;
    var nextBtn = section ? section.querySelector('.ci-fc__nav-btn--next') : null;
    var progressFill = section ? section.querySelector('.ci-fc__progress-fill') : null;

    var slidesDesktop = parseFloat(slider.dataset.slidesDesktop) || 4;
    var slidesTablet = parseFloat(slider.dataset.slidesTablet) || 2;
    var slidesMobile = parseFloat(slider.dataset.slidesMobile) || 1.2;
    var currentIndex = 0;

    function getSlides() {
      return Array.prototype.slice.call(track.querySelectorAll('.ci-fc__slide'));
    }

    function getSlidesPerView() {
      var w = window.innerWidth;
      if (w <= 640) return slidesMobile;
      if (w <= 1024) return slidesTablet;
      return slidesDesktop;
    }

    function getMaxIndex() {
      var slides = getSlides();
      return Math.max(0, Math.ceil(slides.length - getSlidesPerView()));
    }

    function getGap() {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.gap) || parseFloat(styles.columnGap) || 0;
    }

    function getSlideWidth() {
      var perView = getSlidesPerView();
      var gap = getGap();
      return (viewport.offsetWidth - gap * (perView - 1)) / perView;
    }

    function applyWidths() {
      var slideWidth = getSlideWidth();
      getSlides().forEach(function (slide) {
        slide.style.width = slideWidth + 'px';
        slide.style.flex = '0 0 ' + slideWidth + 'px';
      });
    }

    function update() {
      var slides = getSlides();
      if (!slides.length) return;
      applyWidths();
      var slideWidth = getSlideWidth();
      var gap = getGap();
      track.style.transform = 'translateX(-' + currentIndex * (slideWidth + gap) + 'px)';
      if (progressFill) {
        var trackWidth = progressFill.parentElement ? progressFill.parentElement.offsetWidth : 0;
        var maxIndex = getMaxIndex();
        var thumbWidth = slides.length > 0 ? (getSlidesPerView() / slides.length) * trackWidth : trackWidth;
        if (thumbWidth < 40) thumbWidth = 40;
        if (thumbWidth > trackWidth) thumbWidth = trackWidth;
        var travel = trackWidth - thumbWidth;
        var offset = maxIndex > 0 ? (currentIndex / maxIndex) * travel : 0;
        progressFill.style.width = thumbWidth + 'px';
        progressFill.style.transform = 'translateX(' + offset + 'px)';
      }
      if (prevBtn) prevBtn.disabled = currentIndex <= 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function goTo(index) {
      currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
      update();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(currentIndex + 1);
      });
    }

    window.addEventListener('resize', function () {
      goTo(Math.min(currentIndex, getMaxIndex()));
    });

    update();
  }

  function loadSection(root) {
    var exclude = window.ciCurrentProductHandle || '';
    var handles = readHandles().filter(function (h) {
      return h && h !== exclude;
    });

    if (!handles.length) {
      root.hidden = true;
      return;
    }

    var cardsSectionId = root.dataset.ciRvCardsSection || 'ci-recently-viewed-cards';
    var q = handles
      .map(function (h) {
        return 'handle:' + h;
      })
      .join(' OR ');

    fetch('/search?type=product&q=' + encodeURIComponent(q) + '&section_id=' + encodeURIComponent(cardsSectionId))
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newTrack = doc.querySelector('[data-ci-rv-track]');
        var track = root.querySelector('.ci-fc__track');
        if (!newTrack || !track || !newTrack.children.length) {
          root.hidden = true;
          return;
        }
        track.innerHTML = newTrack.innerHTML;

        var orderMap = {};
        handles.forEach(function (h, i) {
          orderMap[h] = i;
        });
        Array.prototype.slice
          .call(track.querySelectorAll('.ci-fc__slide[data-product-handle]'))
          .sort(function (a, b) {
            var ha = a.getAttribute('data-product-handle');
            var hb = b.getAttribute('data-product-handle');
            return (orderMap[ha] !== undefined ? orderMap[ha] : 99) - (orderMap[hb] !== undefined ? orderMap[hb] : 99);
          })
          .forEach(function (slide) {
            track.appendChild(slide);
          });

        root.hidden = false;
        document.dispatchEvent(
          new CustomEvent('ci:product-grid:updated', {
            detail: { root: root },
          })
        );
        var slider = root.querySelector('[data-ci-rv-slider]');
        initSlider(slider);
      })
      .catch(function () {
        root.hidden = true;
      });
  }

  document.querySelectorAll('[data-ci-recently-viewed]').forEach(loadSection);
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-ci-recently-viewed]').forEach(loadSection);
  });
})();
